import React, { useState } from 'react'
import PropTypes from 'prop-types'
import i18next from '../../translations'
import api from '../../api'
import Surface from '../Surface/Surface'
import SurfaceBody from '../SurfaceBody/SurfaceBody'
import PopupButtons from '../PopupButtons/PopupButtons'
import Button from '../Button/Button'
import neutralizeEvent from '../../utils/neutralizeEvent'
import addMessage from '../../utils/addMessage'
import CheckBox from '../CheckBox/CheckBox'
import Popup from '../Popup/Popup.js'
import classes from './DeleteCoachForm.module.scss'

const DeleteCoachForm = (props) => {
  const [fullDeleteChecked, setFullDeleteChecked] = useState(false)
  const [showWarning, setShowWarning] = useState(false)

  const {
    userId,
    teamId,
    coachName,
    teamName,
    onCancel,
    callback,
    isAdmin
  } = props

  const handleSubmit = (event) => {
    neutralizeEvent(event)
    if (isAdmin && fullDeleteChecked) {
      api.user.deleteUser(userId, fullDeleteChecked)
        .then(() => {
          addMessage(
            i18next.t('messages:name_removed_as_coach_from_team', { name: coachName, team: teamName }),
            { type: 'error' }
          )
          callback()
        })
    } else {
      api.user.deleteUserFromTeam(userId, teamId)
        .then(() => {
          addMessage(i18next.t('messages:name_removed_as_coach_from_team', { name: coachName, team: teamName }), { type: 'error' })
          callback()
        })
    }
  }

  function toggleValue (a) {
    setFullDeleteChecked(!fullDeleteChecked)
    if (!fullDeleteChecked) {
      setShowWarning(true)
    }
  }

  function cancelFullDelete () {
    setFullDeleteChecked(false)
    setShowWarning(false)
  }

  function confirmFullDelete () {
    setShowWarning(false)
  }

  return (
    <form onSubmit={handleSubmit}>
      { showWarning &&
        <Popup
          title={i18next.t('actions:delete')}
          onClose={() => setShowWarning(false)}
          body={
            <Surface>
              <SurfaceBody>
                {i18next.t('actions:delete_club_admin_force_confirmation')}
              </SurfaceBody>
              <PopupButtons>
                <Button onClick={cancelFullDelete}>{i18next.t('actions:cancel')}</Button>
                <Button onClick={confirmFullDelete} theme='primary'>{i18next.t('actions:ok')}</Button>
              </PopupButtons>
            </Surface>
          }
        />
      }
      <Surface>
        <SurfaceBody>
          {i18next.t('messages:confirm_delete_coach')}
          {isAdmin &&
            <label className={classes.checkbox}>
              <CheckBox
                name="toggleId"
                checked={fullDeleteChecked}
                onChange={toggleValue}
              />
              <div className={classes.checkboxText}>{i18next.t('actions:delete_coach_force_message')}</div>
            </label>
          }
        </SurfaceBody>
        <PopupButtons>
          <Button onClick={onCancel}>{i18next.t('actions:cancel')}</Button>
          <Button type='submit' theme='primary'>{i18next.t('actions:save')}</Button>
        </PopupButtons>
      </Surface>
    </form>
  )
}

DeleteCoachForm.propTypes = {
  userId: PropTypes.string.isRequired,
  teamId: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired
}

export default DeleteCoachForm
